import {Component, Input, OnInit} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {IOrganization, OrganizationsService} from '../../organizations.service';
import {TranslateModule} from '@ngx-translate/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {ApplicationPipesModule} from '../../../../../application-pipes/application-pipes.module';
import {SurveysService} from '../../surveys.service';
import {ProjectsListComponent} from '../projects-list/projects-list.component';
import {AuthService} from '@app/services/auth/auth.service';
import {MatButtonModule} from '@angular/material/button';
import {RefreshRemoteComponent} from '../refresh-remote/refresh-remote.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LoadingDirectiveModule} from '../../../../loading-directive/loading-directive.module';
import {MatInputModule} from "@angular/material/input";

@Component({
  selector: 'app-references-title',
  templateUrl: './references-title.component.html',
  imports: [
    MatInputModule,
    NgForOf,
    MatIconModule,
    MatChipsModule,
    TranslateModule,
    ApplicationPipesModule,
    AsyncPipe,
    NgIf,
    ProjectsListComponent,
    MatButtonModule,
    RefreshRemoteComponent,
    MatTooltipModule,
    LoadingDirectiveModule,
  ],
  standalone: true,
  styleUrls: ['./references-title.component.scss']
})
export class ReferencesTitleComponent extends OnDestroyMixin implements OnInit {

  @Input()
  displaySurveysCount = true;

  organizationsList: IOrganization[] = [];

  constructor(
    public organizationsService: OrganizationsService,
    public surveysService: SurveysService,
    public auth: AuthService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.organizationsService.organizationsList$
      .pipe(untilComponentDestroyed(this))
      .subscribe((organization) => {
        this.organizationsList = Object.values(organization);
      });


  }
  remove(organization: IOrganization): void {
    this.organizationsService.removeASelectedOrganization(organization?.id);
  }
  refreshSurveys() {
    this.surveysService.refreshSurveys(true);
  }
}
